import React, { useState, useEffect } from "react";

const NavBar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav
        style={{
          width: "100%",
          backgroundColor: "#ffffff",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: isMobile ? "16px" : "64px",
          paddingRight: isMobile ? "16px" : "64px",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            fontSize: isMobile ? "24px" : "32px",
            fontWeight: "bold",
            color: "#2d3748",
            cursor: "pointer",
          }}
          onClick={() => scrollToSection("hero")}
        >
          Etiti <span style={{ color: "#04EEAD" }}>Logistics</span>
        </div>

        <div
          style={{
            display: isMobile ? "none" : "flex",
            gap: "40px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => scrollToSection("our-services")}
            style={{
              background: "none",
              border: "none",
              color: "#1F2937",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#1F2937")}
          >
            Our Services
          </button>
          <button
            onClick={() => scrollToSection("how-it-works")}
            style={{
              background: "none",
              border: "none",
              color: "#1F2937",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#04EEAD")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#1F2937")}
          >
            How it Works
          </button>
        </div>

        <div
          style={{
            display: isMobile ? "none" : "flex",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => scrollToSection("get-in-touch")}
            style={{
              backgroundColor: "transparent",
              color: "#1F2937",
              border: "1px solid #04EEAD",
              padding: "12px 24px",
              borderRadius: "25px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#04EEAD";
              e.currentTarget.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#1F2937";
            }}
          >
            Get in Touch
          </button>
          <button
            onClick={() => (window.location.href = "mailto:uekeledo@gmail.com")}
            style={{
              backgroundColor: "#1F2937",
              color: "#ffffff",
              border: "none",
              padding: "12px 24px",
              borderRadius: "25px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#1a202c")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#1F2937")
            }
          >
            Request a Quote
          </button>
        </div>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            display: isMobile ? "block" : "none",
            backgroundColor: "transparent",
            border: "none",
            fontSize: "24px",
            color: "#2d3748",
            cursor: "pointer",
            padding: "5px",
          }}
        >
          ☰
        </button>
      </nav>

      {isMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "#ffffff",
            zIndex: 1001,
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "60px",
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#2d3748",
              }}
              onClick={() => scrollToSection("hero")}
            >
              Etiti <span style={{ color: "#04EEAD" }}>Logistics</span>
            </div>
            <button
              onClick={() => setIsMenuOpen(false)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                fontSize: "24px",
                color: "#2d3748",
                cursor: "pointer",
                padding: "5px",
              }}
            >
              ✕
            </button>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "40px",
              marginBottom: "60px",
            }}
          >
            <button
              onClick={() => scrollToSection("our-services")}
              style={{
                background: "none",
                border: "none",
                color: "#2d3748",
                fontSize: "18px",
                fontWeight: "500",
                cursor: "pointer",
                textAlign: "left",
                padding: "0",
              }}
            >
              Our Services
            </button>
            <button
              onClick={() => scrollToSection("how-it-works")}
              style={{
                background: "none",
                border: "none",
                color: "#2d3748",
                fontSize: "18px",
                fontWeight: "500",
                cursor: "pointer",
                textAlign: "left",
                padding: "0",
              }}
            >
              How it Works
            </button>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: "auto",
              marginBottom: "40px",
            }}
          >
            <button
              onClick={() =>
                (window.location.href = "mailto:uekeledo@gmail.com")
              }
              style={{
                backgroundColor: "#2d3748",
                color: "#ffffff",
                border: "none",
                padding: "16px 32px",
                borderRadius: "25px",
                fontSize: "16px",
                fontWeight: "500",
                cursor: "pointer",
                width: "100%",
              }}
            >
              Request a Quote
            </button>
            <button
              onClick={() => scrollToSection("get-in-touch")}
              style={{
                backgroundColor: "transparent",
                color: "#1F2937",
                border: "1px solid #04EEAD",
                padding: "16px 32px",
                borderRadius: "25px",
                fontSize: "16px",
                fontWeight: "500",
                cursor: "pointer",
                width: "100%",
              }}
            >
              Get in Touch
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default NavBar;
